import Input, { InputProps } from '@material-ui/core/Input';

export type DSInputProps = InputProps;

export const DSInput = Input;
